/**
 * metaLeadsApi — estado de la integración Meta Lead Ads (solo admin).
 *
 * Lecturas, más dos acciones: `checkMetaLeads` pregunta a Meta (sin cambiar
 * nada allí) si el token, la página y la suscripción están bien, y
 * `retryAllMetaLeads` vuelve a poner en cola los avisos fallidos. Los
 * interruptores y los secretos viven en el entorno del servidor: desde aquí
 * no se encienden ni se ven.
 */
import { api } from "@/lib/api";

export async function getMetaLeadsStatus() {
  const { data } = await api.get(`/admin/integrations/meta-leads/status`);
  return data;
}

export async function getMetaLeadsEvents(limit = 10) {
  const { data } = await api.get(`/admin/integrations/meta-leads/events`, { params: { limit } });
  return data?.events || [];
}

export async function checkMetaLeads() {
  const { data } = await api.post(`/admin/integrations/meta-leads/check`);
  return data;
}

export async function retryAllMetaLeads() {
  const { data } = await api.post(`/admin/integrations/meta-leads/retry-all`);
  return data;
}
